import React, { useEffect, useState } from 'react';
import { MdAdd } from 'react-icons/md';
import { useSelector } from 'react-redux';

import { IconButton } from '~/components/buttons';
import {
  FormContainer,
  HeaderFormContainer,
  SimpleContainer,
} from '~/components/containers';
import { FieldContainer, SelectStyled } from '~/components/Global';
import history from '~/services/history';

import Table from './table';

function Passenger() {
  const [personType, setPersonType] = useState();
  const me = useSelector((state) => state.globalState.me);
  const [editablePermission, setEditablePermission] = useState(false);

  useEffect(() => {
    if (me) {
      if (me.role === 'master') {
        setEditablePermission(true);
      }
      setPersonType('Passageiro');
    }
  }, [me]);
  useEffect(() => {
    if (personType === 'Passageiro') {
      history.push('/passenger');
    }
    if (personType === 'Responsável') {
      history.push('/responsible');
    }
    if (personType === 'Motorista') {
      history.push('/driver');
    }
  }, [personType]);
  return (
    <FormContainer>
      <HeaderFormContainer title="Passageiros">
        <FieldContainer style={{ width: '250px', height: 'auto', padding: 0 }}>
          {/* <label>Tipo de Pessoa</label> */}
          <SelectStyled
            name="type"
            defaultValue={{
              label: personType,
              value: personType,
            }}
            onChange={(option) => setPersonType(option.value)}
            value={{
              label: personType,
              value: personType,
            }}
            options={[
              { label: 'Motorista', value: 'Motorista' },
              { label: 'Responsável', value: 'Responsável' },
              { label: 'Passageiro', value: 'Passageiro' },
            ]}
            isDisabled={!editablePermission}
          />
        </FieldContainer>
        <IconButton
          Icon={MdAdd}
          size={15}
          height="h-8"
          width="w-44"
          onClick={() => history.push('/passenger/form')}
          disabled={!editablePermission}
          type="button"
        >
          Adicionar
        </IconButton>
      </HeaderFormContainer>
      <SimpleContainer>
        <Table />
      </SimpleContainer>
    </FormContainer>
  );
}
export default Passenger;
